import { Upload, notification } from 'antd';
import * as React from 'react';
import { UploadChangeParam, UploadProps } from 'antd/lib/upload/interface';
import { ParagraphMedium } from '../Paragraphs/Paragraphs';
import Title from '../Title';
import "./PbrDocUploader.scss";
import Button from '../Button';

export interface IFileToUpload {
    name: string;
    file: string;
    type: string;
}

export default function PbrDocUploader(props: UploadProps & {
    onChangeBase64?: (fileToUpload: IFileToUpload) => void,
    btnText: string, title: string, subTitle?: string, initialImgUrl?: string 
}) {
    const [imageUrl, setImageUrl] = React.useState(props.initialImgUrl);

    function getBase64(file): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.toString() || '');
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    }

    async function handleChange(info: UploadChangeParam) {
        try {
            const base64 = await getBase64(info.file);
            setImageUrl(base64);
            if (props.onChangeBase64) {
                props.onChangeBase64({ file: base64.split('base64,')[1], name: info.file.name, type: info.file.type });
            }
        } catch (error) {
            notification["error"]({
                message: "Erro ao carregar o arquivo",
                description: "Ocorreu um erro no carregamento do arquivo"
            });
            console.log(error);
        }
    }

    return (
        <>
            <Title size="h4"><b>{props.title}</b></Title>
            {props.subTitle &&
                <ParagraphMedium>{props.subTitle}</ParagraphMedium>
            }
            <Upload
                className="doc-uploader"
                name="avatar"
                showUploadList={false}
                beforeUpload={(file, fileList) => false}
                onChange={(info) => handleChange(info)}
                action={() => null}
                accept="image/jpeg,image/png"
            >
                {
                    imageUrl ?
                        <img src={imageUrl} alt="Avatar" className="avatar" style={{ maxWidth: "100%", cursor: "pointer" }} />
                        :
                        (
                            
                            <Button highlight={ true } type="button">
                                 {props.btnText}
                            </Button>

                        )
                }
            </Upload>
            {imageUrl &&
                <ParagraphMedium style={{ textAlign: "center", color: "#777777", paddingTop: "30px" }}>
                    Clique no arquivo acima se desejar alterar o documento.
                </ParagraphMedium>
            }
        </>
    );
}




// WEBPACK FOOTER //
// ./src/components/common/PbrDocUploader/PbrDocUploader.tsx